import { HTMLAttributes } from "react";
import "./Components.css";

type ContentProps = Pick<HTMLAttributes<HTMLDivElement>, "children" | "className">;

/**
 * メインコンテナのコンポーネントです。
 * @param props - プロパティ
 * @returns メインコンテナのコンポーネント
 */
export const MainContainer = (props: ContentProps): JSX.Element => {
  const { children } = { ...props };

  return <div className={"w-full h-full"}>{children}</div>;
};

/**
 * メインコンテンツのコンポーネントです。
 * @param props - プロパティ
 * @returns メインコンテンツのコンポーネント
 */
export const MainContent = (props: ContentProps): JSX.Element => {
  const { children, className } = { ...props };

  const addClassName = className ? className : "";

  return <div className={`rcui-main-content ${addClassName}`}>{children}</div>;
};

/**
 * Flexコンテナのコンポーネントです。
 * @param props - プロパティ
 * @returns Flexコンテナのコンポーネント
 */
export const CenterFlexContainer = (props: ContentProps): JSX.Element => {
  const { children, className } = { ...props };

  const addClassName = className ? className : "";

  return <div className={`rcui-center-flex-container ${addClassName}`}>{children}</div>;
};

/**
 * コンテンツのタイトルのコンポーネントです。
 * @param props - プロパティ
 * @returns コンテンツのタイトルのコンポーネント
 */
export const ContentTitle = (props: ContentProps): JSX.Element => {
  const { children } = { ...props };

  return <div className="rcui-content-title">{children}</div>;
};

/**
 * ヘッダテキストのコンポーネントです。
 * @param props - プロパティ
 * @returns ヘッダテキストののコンポーネント
 */
export const HeaderText = (props: ContentProps): JSX.Element => {
  const { children } = { ...props };

  return <div className="mb-5 text-2xl">{children}</div>;
};
